// Временное хранилище распознанного меню между стартовой страницей и логином.
// Пользователь загружает фото меню до авторизации; блюда сохраняются здесь,
// а после Auth0-логина импортируются в созданный restaurant (см. userContext).

const STORAGE_KEY = "pendingMenuDishes"

export const savePendingMenu = (dishes) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(dishes || []))
  } catch (error) {
    console.error("Не удалось сохранить распознанное меню:", error)
  }
}

export const getPendingMenu = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : null
  } catch (error) {
    console.error("Не удалось прочитать распознанное меню:", error)
    return null
  }
}

export const clearPendingMenu = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (error) {
    console.error("Не удалось очистить распознанное меню:", error)
  }
}
